var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFolderIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 31,
    viewBox: "0 0 42 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1H13.1716C13.702 1 14.2107 1.21071 14.5858 1.58579L19.4142 6.41421C19.7893 6.78929 20.298 7 20.8284 7H39C40.1046 7 41 7.89543 41 9V27.5C41 28.6046 40.1046 29.5 39 29.5H3C1.89543 29.5 1 28.6046 1 27.5V3C1 1.89543 1.89543 1 3 1Z",
    stroke: "#8D8D8D",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolderIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/folderIcon.cbc4e81c.svg";
export { ForwardRef as ReactComponent };